export default class ExportLog {
    static fromData(data) {
        if (!data) {
            return;
        }

        const exportLog = new ExportLog();
        exportLog.id = data.id;
        exportLog.attachmentName = data.attachmentName;

        Object.seal(exportLog);
        return exportLog;
    }
}
